export declare class LocationEntity {
  public latitude?: number;
  public longitude?: number;
}
